import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import {  map } from 'rxjs/operators';
import { Constants } from 'src/app/data-models/constants.enum';
import { of } from 'rxjs';
import { OauthResponse } from './auth/oauthResponse.model';

@Injectable({
    providedIn: 'root'
  })
  export class ClaimSearchService {
    private  baseServerUrl = environment.baseServerUrl;

    getBaseServerUrl(){
        const resp : OauthResponse = JSON.parse(sessionStorage.getItem("oAuthResponse"));
        if(resp.stargateEnabled){
            this.baseServerUrl = environment.starGateUrl+environment.reportingServiceBaseUrlSuffix;
        }
        else{
            this.baseServerUrl = environment.backedBaseUrl+environment.reportingServiceBaseUrlSuffix;
        }
      }

    constructor(private readonly http: HttpClient) { }

    getClaimSearchResult(clientName, fromDate, toDate, datetype, clientClaimId, optumClaimId, cmsIcn, inbClientFileName, cmsSubmissionFileName, isa13, claimType, billType, placeOfService, contract, orig_Void_Adjust_Indicator, dxCode, providerFirstName, providerLastName, npi, healthPlanProviderId, taxId, providerType, memberDOB: string, memberFirstName: string, memberLastName: string, memberMbi: string, healthPlanMemberId: string, pageCriteria){
            this.getBaseServerUrl();
            return this.http.post<any[]>(`${this.baseServerUrl}/v1/filterclaims`,{clientName,fromDate,toDate,datetype,clientClaimId,optumClaimId,
                cmsIcn,inbClientFileName,cmsSubmissionFileName,isa13,claimType,billType,placeOfService,contract,
                orig_Void_Adjust_Indicator,dxCode,providerFirstName,providerLastName,npi,healthPlanProviderId,taxId,providerType,memberDOB,memberFirstName,memberLastName,memberMbi,healthPlanMemberId,pageCriteria});
        }

    getClaimDetail(fmlyPtntAcctNum,prtySk){
        this.getBaseServerUrl();
        return this.http.get<any[]>(`${this.baseServerUrl}/v1/getClaimDtls/${fmlyPtntAcctNum}/${prtySk}`);
    }

    getClaimAuditDetail(medClaimSk,prtySk){
        this.getBaseServerUrl();
        return this.http.get<any[]>(`${this.baseServerUrl}/v1/fetchClmAudit/${medClaimSk}/${prtySk}`);
    }

    getAllDropDown(){
        this.getBaseServerUrl();
        return this.http.get<any[]>(`${this.baseServerUrl}/v1/claim-dropDowns`);
    }

    getClamAuditMapping(){
        this.getBaseServerUrl();
        return this.http.get<any[]>(`${this.baseServerUrl}/v1/clmAuditMapping`);
    }

    getClmDetailForFullClmView(medClaimSk,prtySk){
        this.getBaseServerUrl();
        return this.http.get<any[]>(`${this.baseServerUrl}/v1/fetchFullClaimDetails/${medClaimSk}/${prtySk}`);
    }

    getCodeDescriptions(codes: { codeType: string; code: string }[]) {
        this.getBaseServerUrl();
        const url = `${this.baseServerUrl}/v1/fetchCodeDescriptions`;
        return this.http.post<any[]>(url, codes);
    }

    getWorklistDetails( medClaimSk){
        this.getBaseServerUrl();
        return this.http.get<any[]>(`${this.baseServerUrl}/v1/fetchLatestFlagStatusDetails/${medClaimSk}`);
    }

    getWorklistDropdown(prtySk){
        this.getBaseServerUrl();
        return this.http.get<any[]>(`${this.baseServerUrl}/v1/fetchClaimStatusFlag/${prtySk}`);
    }

    applyWorklistChanges(reqBody){
        this.getBaseServerUrl();
        const url = `${this.baseServerUrl}/v1/statusFlagAudit`;
        return this.http.post(url, reqBody, { responseType: 'text' });
    }

    getClmErrDetailForFullClmView(medClaimSk,prtySk){
        this.getBaseServerUrl();
        return this.http.get<any[]>(`${this.baseServerUrl}/v1/fetchClmErrDtls/${medClaimSk}/${prtySk}`);
    }

    getClmStateAndStatus(medClaimSk,prtySk){
        this.getBaseServerUrl();
        return this.http.get<any[]>(`${this.baseServerUrl}/v1/fetchPrcsStateAndStatus/${medClaimSk}/${prtySk}`);
    }

    getClaimUpdates(medClaimSk,prtySk){
        this.getBaseServerUrl();
        return this.http.get<any[]>(`${this.baseServerUrl}/v1/getClaimUpdates/${medClaimSk}/${prtySk}`);
    }

    getClmEditableErrors(medClaimSk,prtySk){
        this.getBaseServerUrl();
        return this.http.get<any[]>(`${this.baseServerUrl}/v1/fetchClmEditableErrDtls/${medClaimSk}/${prtySk}`);
    }

    getClmNonEditableErrors(medClaimSk,prtySk){
        this.getBaseServerUrl();
        return this.http.get<any[]>(`${this.baseServerUrl}/v1/fetchClmNonEditableErrDtls/${medClaimSk}/${prtySk}`);
    }

    getHccCodes(claimIds: string[]) {
        const url = `${environment.hccValuationBaseUrl}/process`;
        return this.http.post<any>(url, { claim_ids: claimIds });
    }
}
